import React from "react";

const WhatsAppButton = () => {
  const phone = "918217617245";
  const message = encodeURIComponent(
    "Hello Wellness Minds, I would like to know more about your services."
  );
  const href = "https://wa.me/" + phone + "?text=" + message;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat with Wellness Minds on WhatsApp"
    >
      <svg
        className="whatsapp-icon"
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M16.01 5.003c-5.5 0-9.96 4.412-9.96 9.845 0 1.736.47 3.43 1.36 4.93L6 27l7.4-1.945c1.44.395 2.63.57 3.61.57h.01c5.5 0 9.96-4.41 9.96-9.845 0-2.63-1.05-5.1-2.96-6.96-1.91-1.86-4.46-2.82-7.01-2.82zm5.8 13.477c-.25.7-1.23 1.34-1.86 1.42-.48.06-1.09.09-1.77-.11-.41-.13-.94-.3-1.62-.59-2.85-1.23-4.7-4.09-4.85-4.27-.14-.18-1.16-1.54-1.16-2.94 0-1.4.73-2.08.99-2.36.26-.28.57-.35.76-.35.19 0 .38 0 .55.01.18.01.42-.07.66.5.25.6.85 2.06.93 2.21.07.15.11.32.02.5-.09.18-.14.29-.27.45-.14.16-.29.36-.42.48-.14.12-.29.25-.13.53.16.28.72 1.19 1.54 1.93 1.06.95 1.95 1.25 2.24 1.39.29.14.46.12.63-.07.17-.18.72-.78.91-1.05.19-.28.39-.23.66-.14.27.09 1.74.82 2.04.97.3.15.5.23.57.36.07.14.07.8-.18 1.5z"
          fill="currentColor"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
